import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    ColorPicker,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function SystemTaroffTaroffCollectTimesEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formColor, setFormColor] = useState(null);
    const handleCancel = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handleSave = async () => {
        await postData('/api/panel/page/system-taroff-taroff-collect-times-edit/save-data', {
            id: allProps['taroff-collect-times-id'],
            color: formColor,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/system-taroff-taroff-collect-times-edit/form-data', {
            id: allProps['taroff-collect-times-id'],
        }).then((response) => {
            setFormColor(response.data.color);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش زمان</Title>
                <Grid>
                    <GridColumn width={12}>
                        <ColorPicker label={'رنگ'} value={formColor} onChange={setFormColor} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handleCancel}>انصراف</Button>
                    <Button onClick={handleSave}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
